'use es6';

import { fromJS } from 'immutable';
import { userInfo as getUserInfo } from 'reporting-data/request/user-info';
export default (fn => report => getUserInfo().then(userInfo => fn(report, fromJS(userInfo))));